import React from "react";
import { Stepper, Step, StepLabel } from "@mui/material";
import { useLocation } from "react-router-dom";

const stepperStyles = {
    "& .MuiStepConnector-line": {
        borderColor: "#D9D9D9",
    },
    "& .MuiStepIcon-root": {
        color: "#D9D9D9",
    },
    "& .MuiStepIcon-root.Mui-active": {
        color: "#16BB4D",
    },
    "& .MuiStepIcon-root.Mui-completed": {
        color: "#16BB4D",
    },
    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
        borderColor: "#16BB4D",
    },
    "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
        borderColor: "#16BB4D",
    },
    "& .MuiStepLabel-label": {
        color: "#5C5C5C",
    },
    "& .MuiStepLabel-label.Mui-active": {
        color: "#16BB4D",
    },
    "& .MuiStepLabel-label.Mui-completed": {
        color: "#16BB4D",
    },
};

function VoiceCloningStepper({ steps }) {
    const location = useLocation();
    const activeStep = steps.findIndex((step) =>
        location.pathname.includes(step.path)
    );

    return (
        <Stepper
            activeStep={activeStep}
            orientation="vertical"
            sx={stepperStyles}
        >
            {steps.map((step, index) => (
                <Step key={step.label}>
                    <StepLabel>{step.label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}

export default VoiceCloningStepper;
